<template>
  <div class="page-column">
    <FocusNews></FocusNews>
    <IndustryNotice></IndustryNotice>
  </div>
</template>

<script>
import FocusNews from './FocusNews.vue'
import IndustryNotice from './IndustryNotice.vue'
export default {
  components: {
    FocusNews,
    IndustryNotice
  },
  data () {
    return {

    }
  },
  created () {
    window.scrollTo(0, 0)
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
.page-column {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
}

</style>



// WEBPACK FOOTER //
// src/daoba-match/views/event/news/NewsIndex.vue